import React from 'react';
import RuntimeConfigGrid from './RuntimeConfigGrid';

const TAB_LABELS = { cors: 'CORS', frame: 'Frame', mime: 'MIME' };

const RuntimeConfigBrowseModal = ({
  configId,
  document,
  loading,
  notFound,
  submitting,
  onEdit,
  onRemove,
  onClose,
}) => {
  if (!configId) {
    return null;
  }

  const label = TAB_LABELS[configId] || configId;

  return (
    <div className="runtime-config-browse-panel" data-testid="runtime-config-browse-modal">
      <div className="runtime-config-browse-header">
        <h3>Browse {label} entries</h3>
        <button
          type="button"
          className="runtime-config-browse-close"
          onClick={onClose}
          data-testid="runtime-config-browse-close"
          aria-label="Close browse panel"
        >
          &times;
        </button>
      </div>
      <div className="runtime-config-browse-body">
        <RuntimeConfigGrid
          configId={configId}
          document={document}
          loading={loading}
          notFound={notFound}
          submitting={submitting}
          onEdit={onEdit}
          onRemove={onRemove}
          embedded
        />
      </div>
    </div>
  );
};

export default RuntimeConfigBrowseModal;
